import './index.scss'
import {
  ToastNotification,
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react'

const Notification = Object.assign({}, ToastNotification, {
  Toast: ToastNotification,
  Inline: InlineNotification,
  ActionButton: NotificationActionButton
})

export {
  Notification,
  ToastNotification,
  InlineNotification,
  NotificationActionButton,
  Notification as default
}
